<template>
  <div>
    <h2 class="content-heading">
      <i class="si si-tag mr-5"></i> Producten
      <div style="float: right">
        <button type="button" class="btn btn-sm btn-success btn-noborder float-right" @click="openCreateProductModal">
          <i class="fa fa-plus mr-5"></i>Nieuwe Product
        </button>
      </div>

      <div style="float: right">
        <small class="mr-1">Genereer:</small>
        <a @click="showStickerGenerator" target="_blank" class="btn btn-sm btn-secondary"><i class="fa fa-file-pdf-o text-danger mr-1"></i> Locatie labels</a>
      </div>
    </h2>

    <api-table-block ref="productsTable" :fields="fields" :items="findAllProducts" default-sort-by="created_at" item-label-singular="product" item-label-plural="producten">
      <template slot="image" slot-scope="data">
        <img class="img-avatar img-avatar48" :src="data.item.image_urls[0]" :key="data.item.id" alt="">
      </template>
      <template slot="name" slot-scope="data">
        <a href="#" @click.prevent="details(data.item)">{{data.value}}</a>
      </template>
      <template slot="price" slot-scope="data">
        <sale-price-editable v-if="data.item.sale_price" :price="data.item.price" :sale_price="data.item.sale_price" :product-id="data.item.id" :key="data.item.id"></sale-price-editable>
        <price-editable v-else :price="data.item.price" :product-id="data.item.id" :key="data.item.id" ></price-editable>
      </template>
      <template slot="location" slot-scope="data">
        <div>
          <location-editable field="location" :value="data.item.location" :product-id="data.item.id" :key="data.item.id"></location-editable>
        </div>
        <div>
          <small>
            Rest:
            <field-editable field="overstock_location" :value="data.item.overstock_location" :product-id="data.item.id" :key="data.item.id"></field-editable>
          </small>
        </div>
      </template>
      <template slot="in_store" slot-scope="data">
        <in-store-editable :in-store="!!data.value" :product-id="data.item.id" :key="data.item.id"></in-store-editable>
      </template>
      <template slot="stock_quantity" slot-scope="data">
        <stock-editable :quantity="data.value" :product-id="data.item.id" :key="data.item.id"></stock-editable>
      </template>
    </api-table-block>
    <select-barcode-scanner-widget></select-barcode-scanner-widget>
    <product-detail-modal v-if="detailModalProductId" :key="detailModalProductId" :product-id="detailModalProductId" @close="detailModalProductId = null" @remove="refresh"></product-detail-modal>
    <unkown-product-modal v-if="unkownProductScanned" :barcode="scannedBarcode" @close="unkownProductScanned = null, scannedBarcode = null" @unkownProductCreated="handleUnkownProductCreated"></unkown-product-modal>
    <location-sticker-generator v-if="showStickerGeneratorModal" @close="showStickerGeneratorModal = null"></location-sticker-generator>
    <update-location-modal v-if="locationScanned" :location="scannedLocation" :productId="detailModalProductId" @close="scannedLocation = null, locationScanned = null"></update-location-modal>
    <location-scanned-modal v-if="productsOnScannedLocation" :products="productsOnScannedLocation" @select="details" @close="productsOnScannedLocation = null"></location-scanned-modal>
    <create-product-modal v-if="showCreateProductModal" @close="showCreateProductModal = false"></create-product-modal>
  </div>
</template>

<script>
import http from '../utils/http'
import LocationEditable from './LocationEditable'
import FieldEditable from './FieldEditable'
import StockEditable from './StockEditable'
import InStoreEditable from './InStoreEditable'
import PriceEditable from './PriceEditable.vue'
import SalePriceEditable from './SalePriceEditable.vue'
import ApiTableBlock from '../common/ApiTableBlock'
import ProductDetailModal from './ProductDetailModal'
import SelectBarcodeScannerWidget from '../barcode-scanner/SelectBarcodeScannerWidget.vue'
import Socket from '../barcode-scanner/socket'
import UnkownProductModal from './UnkownProductModal.vue'
import LocationStickerGenerator from './LocationStickerGenerator.vue'
import UpdateLocationModal from './UpdateLocationModal.vue'
import LocationScannedModal from './LocationScannedModal'
import CreateProductModal from './CreateProductModal'

export default {
  components: {
    LocationEditable,
    FieldEditable,
    StockEditable,
    InStoreEditable,
    ApiTableBlock,
    ProductDetailModal,
    PriceEditable,
    SalePriceEditable,
    SelectBarcodeScannerWidget,
    UnkownProductModal,
    LocationStickerGenerator,
    UpdateLocationModal,
    LocationScannedModal,
    CreateProductModal
  },
  data () {
    return {
      fields: {
        image: {
          label: '',
          class: 'text-center',
          thStyle: 'width: 8%;'
        },
        name: {
          label: 'Product',
          thStyle: 'width: 40%;',
          sortable: true
        },
        price: {
          label: 'Prijs',
          thStyle: 'width: 12%;',
          sortable: true
        },
        location: {
          label: 'Locaties',
          thStyle: 'width: 20%;',
          sortable: true
        },
        in_store: {
          label: 'In winkel',
          thStyle: 'width: 10%;',
          sortable: true
        },
        stock_quantity: {
          label: 'Voorraad',
          thStyle: 'width: 10%;',
          sortable: true
        }
      },
      detailModalProductId: null,
      unkownProductScanned: null,
      scannedBarcode: null,
      showStickerGeneratorModal: null,
      scannedLocation: null,
      productsOnScannedLocation: null,
      locationScanned: null,
      showCreateProductModal: false
    }
  },
  methods: {
    findAllProducts (params) {
      return http.get('/products', { params })
    },
    details (product) {
      this.detailModalProductId = product.id
    },
    refresh () {
      this.$refs.productsTable.refresh()
    },
    handleMessage (event) {
      const endpoint = event.includes('.') ? 'location-scanned' : 'product-scanned'

      http.get(`/${endpoint}/${event}`)
      .then((result) => {
        if (result.data.data === 'unknown_product') {
          this.unkownProductScanned = true
          this.scannedBarcode = event

          return
        } else if (result.data.data === 'unknown_location' && this.detailModalProductId) {
          this.scannedLocation = event
          this.locationScanned = true

          return
        } else if (endpoint === 'location-scanned') {
          if (result.data.data.length === 1) {
            this.detailModalProductId = result.data.data[0].id

            return
          }

          this.productsOnScannedLocation = result.data.data
          return
        }
        this.detailModalProductId = result.data.data.id
      })
      .catch(() => {
        this.$swal('Ehmm...', 'Deze product konden we niet vinden. Probeer het opnieuw.', 'warning')
      })
    },
    handleUnkownProductCreated (event) {
      this.detailModalProductId = event.product.id
    },
    showStickerGenerator () {
      this.showStickerGeneratorModal = true
    },
    openCreateProductModal () {
      this.showCreateProductModal = true
    }
  },
  created () {
    Socket.$on('message', this.handleMessage)
  },
  beforeDestroy () {
    Socket.$off('message', this.handleMessage)
  }
}
</script>



// WEBPACK FOOTER //
// ProductsPage.vue?14eee37d